class GiganiCartCheckoutBar {
  constructor() {
    this.freeShippingThreshold = 39900;
    this.shippingCharge = 5000;
    this.refreshTimer = null;

    this.initialize();
    this.observeCartChanges();
  }

  formatMoney(cents) {
    const amount = Number(cents || 0) / 100;

    return `₹${amount.toLocaleString('en-IN', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    })}`;
  }

  initialize() {
    const checkoutArea = document.querySelector(
      '#main-cart-footer .cart__ctas'
    );

    if (!checkoutArea) return;

    let summary = checkoutArea.querySelector(
      '.gigani-checkout-summary'
    );

    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'gigani-checkout-summary';

      summary.innerHTML = `
        <div class="gigani-checkout-summary__offer">
  <span class="gigani-checkout-summary__offer-main">
    5% OFF
  </span>

  <span class="gigani-checkout-summary__offer-small">
    ON PREPAID
  </span>
</div>

<div class="gigani-checkout-summary__right">
  <div class="gigani-checkout-summary__total">
    Cart Total:
    <strong data-gigani-cart-total></strong>
  </div>

  <div
    class="gigani-checkout-summary__shipping"
    data-gigani-shipping-message
  ></div>
</div>
      `;

      checkoutArea.prepend(summary);
    }

    this.refreshCart();
  }

  async refreshCart() {
    try {
      const response = await fetch(`${window.routes.cart_url}.js`, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        },
        credentials: 'same-origin'
      });

      if (!response.ok) {
        throw new Error(`Unable to load cart: ${response.status}`);
      }

      const cart = await response.json();
      this.render(cart);
    } catch (error) {
      console.error('Gigani checkout bar error:', error);
    }
  }

  render(cart) {
    const totalElement = document.querySelector(
      '[data-gigani-cart-total]'
    );

    const shippingElement = document.querySelector(
      '[data-gigani-shipping-message]'
    );

    if (!totalElement || !shippingElement) return;

    const cartTotal = Number(cart.total_price || 0);

    totalElement.textContent = this.formatMoney(cartTotal);

    if (cartTotal >= this.freeShippingThreshold) {
      shippingElement.textContent = '✓ FREE delivery unlocked';

      shippingElement.classList.add(
        'gigani-checkout-summary__shipping--free'
      );
    } else {
      const remainingAmount =
        this.freeShippingThreshold - cartTotal;

      shippingElement.textContent =
        `Shipping ${this.formatMoney(this.shippingCharge)} • ` +
        `Add ${this.formatMoney(remainingAmount)} more for FREE delivery`;

      shippingElement.classList.remove(
        'gigani-checkout-summary__shipping--free'
      );
    }
  }

  scheduleRefresh() {
    window.clearTimeout(this.refreshTimer);

    this.refreshTimer = window.setTimeout(() => {
      this.initialize();
    }, 350);
  }

  observeCartChanges() {
    const observer = new MutationObserver(() => {
      this.scheduleRefresh();
    });

    const cartFooter = document.getElementById(
      'main-cart-footer'
    );

    if (cartFooter) {
      observer.observe(cartFooter, {
        childList: true,
        subtree: true
      });
    }

    document.addEventListener('change', (event) => {
      if (
        event.target.closest('cart-items') ||
        event.target.closest('#main-cart-items')
      ) {
        this.scheduleRefresh();
      }
    });

    document.addEventListener('click', (event) => {
      if (
        event.target.closest('cart-remove-button') ||
        event.target.closest('[name="plus"]') ||
        event.target.closest('[name="minus"]')
      ) {
        this.scheduleRefresh();
      }
    });
  }
}

function initializeGiganiCartCheckoutBar() {
  if (!document.getElementById('main-cart-footer')) return;

  if (window.giganiCartCheckoutBar) {
    window.giganiCartCheckoutBar.initialize();
    return;
  }

  window.giganiCartCheckoutBar =
    new GiganiCartCheckoutBar();
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeGiganiCartCheckoutBar
  );
} else {
  initializeGiganiCartCheckoutBar();
}